module.exports = __webpack_public_path__ + "static/media/normal.54ac83c4.svg";